import { useAppContext } from '../../Services/AppContext';
import { Order } from './CaseChatEntry';
import FirstUpper from '../FirstUpper';

interface CaseChatEntryOrderTotalProps {
	order: Order;
}

export default function CaseChatEntryOrderTotal(
	props: CaseChatEntryOrderTotalProps,
) {
	const { translation } = useAppContext();
	const { order } = props;

	return (
		<div className='chat-message__order__body__item'>
			<div className='chat-message__order__body__item__title total'>
				<FirstUpper>{translation['base.total']}</FirstUpper>
			</div>
			<div className='chat-message__order__body__item__price total'>
				{order.price.formattedPrice}
			</div>
		</div>
	);
}
